import React, { lazy } from 'react'
import { useLocation } from "react-router-dom";

// Libraries
import { Link } from 'react-router-dom';
import { Button, Col, Container, Navbar, Row } from 'react-bootstrap';
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import { m } from "framer-motion";

// Components
import { fadeIn, zoomIn } from '../../Functions/GlobalAnimations';
import Tab01 from '../../Components/Tab/Tab01';
import TabTraffic from '../../Components/Tab/TabTraffic';
import Counter from '../../Components/Counters/Counter'
import BlogClassic from '../../Components/Blogs/BlogClassic';
import SocialIcons from '../../Components/SocialIcon/SocialIcons';
import CustomModal from '../../Components/CustomModal'
import Header, { HeaderLanguage, HeaderNav, Menu, SearchBar, Topbar } from '../../Components/Header/Header';
import FooterMenu, { Footer } from '../../Components/Footers/Footer';
import SideButtons from "../../Components/SideButtons";

// Data
import { InteractiveBannersData02 } from '../../Components/InteractiveBanners/InteractiveBannersData';
import { TabData01, TabDataTraffic } from '../../Components/Tab/TabData';
import { blogData } from '../../Components/Blogs/BlogData';
import InViewPort from '../../Components/InViewPort';

//Scss
import "../../Assets/scss/default.scss";

const IconWithText = lazy(() => import('../../Components/IconWithText/IconWithText'))

const SwiperData = [
  {
    img: "/assets/img/webp/IMT_DC.jpg",
    title: "Giải pháp tin cậy cho những vấn đề phức tạp",
    subtitle: "Viễn thông, Giám sát An Ninh, Giao Thông",
  },
  {
    img: "/assets/img/webp/IMT_CC.webp",
    title: "Thiết kế giải pháp Giám sát an ninh diện rộng",
    subtitle: "Quy mô giám sát trên địa bàn huyện, thành phố, toàn quốc.",
  },
  {
    img: "/assets/img/webp/TMC.jpg",
    title: "Thiết kế giải pháp Giao thông thông minh (ITS)",
    subtitle: "Tối ưu điều hành giao thông theo chuẩn quốc gia & quốc tế",
  },
]

const TrafficControlPageData = {
  img: "/assets/img/webp/traffic.jpeg",
  content: "Established in 2017. We are a leading technology company in Vietnam with years of experience delivering innovative and high-performance technology solutions. We specialize in wide-area security surveillance, intelligent traffic systems, data analytics, and system architecture design.",
  title: "Intelligence Traffic System (ITS)",
  button: "Our solutions"
};

const PiechartData = [
  {
    percentage: 92,
    title: 'Innovative solutions',
    content: 'Lorem ipsum is simply dummy text of the printing and type.'
  },
  {
    percentage: 90,
    title: 'Marketing strategy',
    content: 'Lorem ipsum is simply dummy text of the printing and type.'
  },
]

const ClientData = [
  {
    img: 'https://via.placeholder.com/300x86'
  },
  {
    img: 'https://via.placeholder.com/300x86'
  },
  {
    img: 'https://via.placeholder.com/300x86'
  },
  {
    img: 'https://via.placeholder.com/300x86'
  }
]

const SocialIconsData = [
  {
    color: "#0038e3",
    link: "https://www.facebook.com/",
    icon: "fab fa-facebook-f"
  },
  {
    color: "#0038e3",
    link: "https://dribbble.com/",
    icon: "fab fa-dribbble"
  },
  {
    color: "#0038e3",
    link: "https://twitter.com/",
    icon: "fab fa-twitter"
  },
  {
    color: "#0038e3",
    link: "https://www.instagram.com/",
    icon: "fab fa-instagram"
  }
]

const IconWithTextData = [
  {
    icon: "line-icon-Monitoring text-[#b7b7b7] text-[40px]",
    title: "Giải pháp giám sát an ninh diện rộng",
    content:
      "Hệ thống giám sát an ninh là một phần cốt yếu của của cuộc sống hiện đại trong các đô thị. Từ những hệ thống giám sát truy nhập access control, cảm biến và alarm panel đến sự hiện diện của CCTV mọi chỗ mọi nơi, tất cả đều được giám sát và xử lý bởi hệ thống trung tâm Bricks của InMeeting. Chúng tôi có khả năng tư vấn, thiết kế, tích hợp, sản xuất và lắp đặt các hệ thống an ninh cho một trường đại học, một phường, huyện, đến địa bàn một Tỉnh/Thành;  hay cả mạng giám sát an ninh cho một ngân hàng với chi nhánh trải rộng trên Toàn quốc. Chúng tôi am hiểu việc xây dựng hạ tầng CCTV, từ sử dụng mạng Metro cho địa bàn một địa phương, đến mạng SDWAN an ninh chạy trên địa bàn Toàn quốc. Chúng tôi am hiểu xây dựng mạng thu thập, lưu trữ, phân phối dữ liệu video CCTV, tối ưu nhất với hạ tầng mạng và nhu cầu sử dụng, cũng như chi phí lưu trữ $cents/GB phù hợp nhất. Chúng tôi quen thuộc với các kỹ thuật phân tích AI, cho các môi trường an ninh, nhận dạng, giao thông, giải quyết các bài toán an ninh của địa phương, doanh nghiệp. Trong lĩnh vực thiết kế, thi công hệ thống giám sát an ninh, cùng với các đối tác, chúng tôi là chuyên gia tin cậy.  .",
  },
  {
    icon: "line-icon-traffic-Light text-[#b7b7b7] text-[40px]",
    title: "Giải pháp giao thông thông minh (ITS)",
    content:
      "Hệ thống ITS là hệ thống công cụ đa lĩnh vực (Sensors, Communications, Data Processing) nhằm cung cấp khả năng quản lý và điều hành các tuyến giao thông, từ cao tốc huyết mạch đến các mạng lưới giao thông đô thị bận rộn. Với đội ngũ chuyên gia trong nước và quốc tế, chúng tôi sẵn sàng hỗ trợ từ khâu lập báo cáo cơ sở, thiết kế kỹ thuật, bảo vệ dự toán, và thi công các dự án ITS trong nước. Tích hợp và tối ưu các thành phần ITS tiêu chuẩn: ramp meter, CCTV, traffic analytics, WIM, traffic controller đến các trung tâm điều hành TMC trong data center theo hướng dẫn và qui chuẩn EU/Bắc Mỹ/ISO, đảm bảo chi phí đầu tư, khả năng vận hành, chi phí bảo trì trong suốt vòng đời dịch vụ là tối ưu nhất cho người đầu tư và vận hành hệ thống. Cam kết đồng hành cùng đội ngũ vận hành giao thông, chúng tôi cũng cung cấp dịch vụ tối ưu điều hành giao thông, viết và cập nhật các qui trình vận hành tuyến (concept of operations) để đảm bảo khai thác tối đa hạ tầng giao thông hiện có.",
  },
  {/*{
    icon: "line-icon-Talk-Man text-[#b7b7b7] text-[40px]",
    title: "Customer satisfaction",
    content:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit do eiusmod tempor.",
  },
  {
    icon: "line-icon-Cursor-Click2 text-[#b7b7b7] text-[40px]",
    title: "No coding required",
    content:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit do eiusmod tempor.",
  },*/}
];

// Filter the blog data category wise
const blogClassicdData = blogData.filter((item) => item.blogType === "classic").filter(item => item.category.includes("business"));

const useScrollToLocation = () => {
  const scrolledRef = React.useRef(false);
  const { hash } = useLocation();
  const hashRef = React.useRef(hash);

  //React.useEffect(() => {
    if (hash) {

      // We want to reset if the hash has changed
      if (hashRef.current !== hash) {
        hashRef.current = hash;
        scrolledRef.current = false;
      }

      // only attempt to scroll if we haven't yet (this could have just reset above if hash changed)
      if (!scrolledRef.current) {

        const id = hash.replace('#', '');
        console.log(`id=${id}`);
        const element = document.getElementById(id);
        console.log(element);
        if (element) {
          console.log(`scroll to element ${id}`);
          element.scrollIntoView({ behavior: 'smooth' });
          scrolledRef.current = true;
        }
      }
    }
  //});
};

const TrafficControllPage = (props) => {
  window.onhashchange = useScrollToLocation();
   return (
    <div style={props.style}>
      <SideButtons />
      {/* Header Start */}
      <Header className="header-with-topbar" topSpace={{ desktop: true }} type="reverse-scroll">
        <HeaderNav fluid="fluid" theme="light" bg="white" menu="light" className="px-[35px] py-[0px] md:px-[15px] sm:px-0" containerClass="md:px-0">
          <Col className="col-auto col-sm-6 col-lg-2 me-auto ps-lg-0">
            <Link aria-label="header logo" className="flex items-center" to="/">
              <Navbar.Brand className="inline-block p-0 m-0">
                <img className="default-logo" width="111" height="108" loading="lazy" src="/assets/img/webp/logo-fast-blue-black_IMT.svg" data-rjs="/assets/img/webp/logo-fast-blue-black@2x_IMT.svg" alt="logo" />
                <img className="alt-logo" width="111" height="108" loading="lazy" src="/assets/img/webp/logo-fast-blue-black_IMT.svg" data-rjs="/assets/img/webp/logo-fast-blue-black@2x_IMT.svg" alt="logo" />
                <img className="mobile-logo" width="111" height="108" loading="lazy" src="/assets/img/webp/logo-fast-blue-black_IMT.svg" data-rjs="/assets/img/webp/logo-fast-blue-black@2x_IMT.svg" alt="logo" />
              </Navbar.Brand>
            </Link>
          </Col>
          <Navbar.Toggle className="order-last md:mx-[15px]">
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
          </Navbar.Toggle>
          <Navbar.Collapse className="col-auto justify-end p-0">
            <Menu {...props}/>
          </Navbar.Collapse>
          <Col className="col-auto text-right !pr-0 pl-[15px] md:pl-0 md:pr-[15px] sm:pr-0">
            {/*<SearchBar className="pl-[17px] xs:px-[15px]" />
            <HeaderLanguage className="pl-[17px] xs:pl-0 xs:pr-0" />*/}
          </Col>
        </HeaderNav>
      </Header>
      {/* Header End */}
      {/* Section Introduction Start */}
      <section className='full-screen md:h-[600px] sm:h-[500px]'>
        <SwiperSlide style={{ backgroundImage: `url(${TrafficControlPageData.img})` }} className="bg-no-repeat	bg-cover	overflow-hidden relative bg-center">
                  <div className="absolute h-full w-full top-0 left-0 bg-gradient-dark-slate-blue"></div>
                  <Container className="h-full text-white">
                    <Row style={{height: "50%"}}>
                      <Col xl={7} lg={7} sm={8} xs={12} className="h-full text-white font-serif justify-center flex-col relative flex">
                        <h4 className="font-semibold default-font-family-bold" style={{textAlign: "justify"}}>{TrafficControlPageData.title.toUpperCase()}</h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={5} lg={7} sm={8} xs={12} className="h-full text-white font-serif justify-center flex-col relative flex">
                        <p className="mb-[40px] font-light text-xmd opacity-70 xs:mb-[20px] default-font-family" style={{textAlign: "justify"}}>{TrafficControlPageData.content}</p>
                      </Col>
                    </Row>
                    <Row>
                        <Col xl={5} lg={7} sm={8} xs={12}  className="bg-blue-600 text-white py-3 px-6 rounded-lg shadow-lg transition duration-300 hover:bg-blue-800 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 cursor-pointer" >{TrafficControlPageData.button}</Col>
                    </Row>
                  </Container>
                </SwiperSlide>
      </section>
      {/* Section Introduction End*/}

      {/*Section Service */}
      <section>
      <div className="text-[15px] uppercase text-purple-800 ml-[180px]" style={{height: "100px", width: "100%", alignItems: "center", display: "flex"}}>
        Intelligence Traffic System
      </div>
         <m.section className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] mt-[-100px]" {...fadeIn}>
          <Container>
            <TabTraffic data={TabDataTraffic} />
          </Container>
        </m.section>
      </section>
      {/*Section End*/}
     
      {/* Section End */}

      {/* Lazy Load HTML */}
      <InViewPort>
        <section id="contact">
          <Container>
            <h5 class="text-center font-serif font-semibold text-darkgray tracking-[-0.5px] mb-[35px] sm:mb-[30px]">THÔNG TIN LIÊN HỆ</h5>
            <div class="w-full shrink-0 grow-0 basis-auto lg:w-7/12">
              <div class="flex flex-row">
                <div class="mb-12 w-1/3 shrink-0 grow-0 basis-auto md:w-6/12 md:px-3 lg:px-6">
                  <div class="flex items-start">
                    <div class="shrink-0">
                      <div class="inline-block rounded-md bg-primary-100 p-4 text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                          stroke="currentColor" class="h-6 w-6">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
                        </svg>
                      </div>
                    </div>
                    <div class="ml-6 grow">
                      <p class="mb-2 font-bold dark:text-white">
                        Kinh doanh
                      </p>
                      <p class="text-neutral-500 dark:text-neutral-200">
                        <a href="mailto:sales@inmeeting.com.vn">sales@inmeeting.com.vn</a>
                      </p>
                      <p class="text-neutral-500 dark:text-neutral-200">
                        +84 24 7300 7966
                      </p>
                    </div>
                  </div>
                </div>
                <div class="mb-12 w-1/3 shrink-0 grow-0 basis-auto md:w-6/12 md:px-3 lg:px-6">
                  <div class="flex items-start">
                    <div class="shrink-0">
                      <div class="inline-block rounded-md bg-primary-100 p-4 text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                          stroke="currentColor" class="h-6 w-6">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0l6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z" />
                        </svg>
                      </div>
                    </div>
                    <div class="ml-6 grow">
                      <p class="mb-2 font-bold dark:text-white">
                        Hỗ trợ kỹ thuật
                      </p>
                      <p class="text-neutral-500 dark:text-neutral-200">
                        <a href="mailto:support@inmeeting.com.vn">support@inmeeting.com.vn</a>
                      </p>
                      <p class="text-neutral-500 dark:text-neutral-200">
                        +84 24 7300 7966
                      </p>
                    </div>
                  </div>
                </div>
                <div class="mb-12 w-1/3 shrink-0 grow-0 basis-auto md:w-6/12 md:px-3 lg:px-6">
                  <div class="align-start flex">
                    <div class="shrink-0">
                      <div class="inline-block rounded-md bg-primary-100 p-4 text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                          stroke="currentColor" class="h-6 w-6">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                        </svg>
                      </div>
                    </div>
                    <div class="ml-6 grow">
                      <p class="mb-2 font-bold dark:text-white">Thông tin</p>
                      <p class="text-neutral-500 dark:text-neutral-200">
                        <a href="mailto:info@inmeeting.com.vn">info@inmeeting.com.vn</a>
                      </p>
                      <p class="text-neutral-500 dark:text-neutral-200">
                        +84 24 7300 7966
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>

        {/* Footer Start */}
        <Footer className="bg-[#262b35] text-slateblue" theme="dark">
          <div className="py-[2%] lg:py-[2%] sm:py-[50px]">
            <Container>
              <Row className="justify-between md:justify-center sm:justify-between">
                <Col className="m-0 md:text-center sm:text-start" lg={{ offSet: 0, span: 3, order: 0 }} sm={{ span: 6, order: 5, offSet: 2 }} md={{ span: 4, offset: 0, order: 5 }} xs={{ span: 12, order: 5, offSet: 2 }}>
                  <Link to="/" className="text-slateblue mb-[15px] mt-[5px] inline-block">
                    <img loading="lazy" src="/assets/img/webp/logo-fast-blue-white_IMT.svg" alt="logo" width="111" height="36" />
                  </Link>
                  <p className="mb-[10px] text-slateblue sm:w-[90%] md:mb-[10px] md:text-center sm:text-start">Email: info@inmeeting.com.vn</p>
                  <p className="mb-[10px] text-slateblue sm:w-[90%] md:mb-[10px] md:text-center sm:text-start">Phone: +84 24 7300 7966</p>
                  <p>© Copyright {new Date().getFullYear()} <Link to="/" className="underline underline-offset-4 text-white font-normal"> inMeeting JSC</Link></p>
                </Col>
                {/*
                <FooterMenu data={FooterData.slice(0, 4)} lg={{ span: 2, offSet: 1, order: 0 }} md={{ span: 3, order: 0 }} sm={{ span: 4, offSet: 1, order: 2 }} className="xl:px-[15px] md:mb-[40px] xs:mb-[25px]" titleClass="capitalize" />
                */}
                <Col >
                <p className="mb-[10px] text-slateblue sm:w-[90%] md:mb-[10px] md:text-center sm:text-start text-justify"> Trong lĩnh vực của mình: giám sát an ninh, giao thông thông minh, truyền thông hợp nhất (UC), chúng tôi là chuyên gia. Chuyên gia không phải từ phòng lab, mà là kinh nghiệm thực chiến tích lũy qua quá trình thiết kế, thử nghiệm, tối ưu, triển khai, vận hành các hệ thống cung cấp dịch vụ IT lớn nhất trong toàn quốc: mạng CDN, viễn thông, video conference, backbone quốc gia,...Tối ưu, hiệu quả, sáng tạo, thực tế là tiêu chí của chúng tôi, và cũng là những gì chúng tôi cam kết mang lại cho dự án của khách hàng</p>
                </Col>
              </Row>
            </Container>
          </div>
        </Footer>
        {/* Footer End */}
      </InViewPort>
    </div>
  )
}

export default TrafficControllPage